import React, { useEffect, useState } from 'react';
import { Row, Col, Typography } from 'antd';
import { SlideContainer } from './SlideContainer';
import slideMunicipiosImg from '../assets/SlideMunicipios2.jpg';
import { ISlidePropostaData } from '../interface';
import ConfiguracaoGeralPropostaService from '../../../services/http/services/Propostas/ConfiguracaoGeralPropostaService';

const { Title, Paragraph, Text } = Typography;

const cidadesPadrao = [
  'Castro – PR',
  'Caxias – MA',
  'Cosmópolis – SP',
  'Itambé – PR',
  'Laguna – SC',
  'Santana de Parnaíba – SP',
  'Patrocínio – MG',
  'Aparecida do Taboado – MS',
  'Tauá – CE',
  'Itaberaba – BA',
  'Campos de Júlio – MT',
  'Porto Velho – RO',
  'Angra dos Reis – RJ',
  'Cachoeira do Arari – PA',
  'Dom Expedito Lopes – PI',
  'Tarauacá – AC',
  'Viamão – RS',
  'Araguaçu – TO',
  'São Joaquim do Monte – PR',
  'AMA – AL',
  'FAMUP – PB',
  'FEMURN – RN',
  'AMREC – SC',
];

export interface SlideMunicipiosProps {
  data?: ISlidePropostaData;
  scale?: number;
}

let cachedMunicipios: string[] | null = null;

export const SlideMunicipios: React.FC<SlideMunicipiosProps> = ({ scale = 1, data }) => {
  const cidadesIniciais = (data?.municipios_destaque && data.municipios_destaque.length > 0)
    ? data.municipios_destaque
    : (cachedMunicipios || cidadesPadrao);

  const [listaCidades, setListaCidades] = useState<string[]>(cidadesIniciais);

  useEffect(() => {
    if (data?.municipios_destaque && data.municipios_destaque.length > 0) {
      setListaCidades(data.municipios_destaque);
      cachedMunicipios = data.municipios_destaque;
      return;
    }

    let isMounted = true;

    const carregarMunicipiosConfigurados = async () => {
      try {
        const configGeral = await ConfiguracaoGeralPropostaService.get();

        if (configGeral?.municipios_destaque && configGeral.municipios_destaque.length > 0) {
          cachedMunicipios = configGeral.municipios_destaque;
          if (isMounted) {
            setListaCidades(configGeral.municipios_destaque);
          }
        }
      } catch (error) {
        console.error('Erro ao carregar municípios da configuração geral:', error);
      }
    };

    carregarMunicipiosConfigurados();

    return () => {
      isMounted = false;
    };
  }, [data?.municipios_destaque]);

  return (
    <SlideContainer
      showWaves={false}
      showFooterLogo={false}
      backgroundImage={slideMunicipiosImg}
      scale={scale}
      data={data}
    >
      <Row gutter={40} align="middle" style={{ height: '100%', paddingBottom: 40 }}>
        {/* Coluna 1: Texto Institucional */}
        <Col span={9} style={{ paddingLeft: 40 }}>
          <div style={{ marginBottom: 28 }}>
            <Title level={2} italic style={{ color: '#0077b6', margin: 0, fontSize: 48, fontWeight: 900, letterSpacing: -0.5 }}>
              SOMOS A
            </Title>
            <Title level={1} italic style={{ color: '#5ea31b', margin: 0, fontSize: 72, fontWeight: 900, lineHeight: 1, letterSpacing: -1 }}>
              GOVFÁCIL
            </Title>
          </div>

          <Paragraph style={{ fontSize: 23, color: '#0f172a', textAlign: 'justify', lineHeight: 1.55, fontWeight: 700 }}>
            Uma empresa paranaense, que em constante estudo tecnológico e científico, tem buscado colaborar com a melhoria da gestão pública municipal, facilitando o acesso a informações estratégicas e promovendo maior transparência e eficiência na tomada de decisões.
          </Paragraph>
        </Col>

        {/* Coluna 2: Mapa Central + Números */}
        <Col span={9} style={{ height: '100%', position: 'relative' }}>
          <div
            style={{
              position: 'absolute',
              bottom: 120,
              right: 20,
              textAlign: 'center',
              zIndex: 10,
            }}
          >
            <Text italic style={{ fontSize: 24, color: '#0f172a', fontWeight: 800, display: 'block' }}>
              Presente em
            </Text>
            <Text style={{ fontSize: 44, fontWeight: 900, color: '#0077b6', display: 'block', lineHeight: 1 }}>
              25 Estados
            </Text>

            <Text italic style={{ fontSize: 22, color: '#0f172a', fontWeight: 800, display: 'block', marginTop: 10 }}>
              Aproximadamente
            </Text>
            <Text style={{ fontSize: 38, fontWeight: 900, color: '#0077b6', display: 'block', lineHeight: 1 }}>
              1000 municípios
            </Text>
            <Text italic style={{ fontSize: 18, color: '#334155', fontWeight: 700 }}>
              entre eles:
            </Text>
          </div>
        </Col>

        {/* Coluna 3: Lista de Municípios */}
        <Col span={6} style={{ paddingRight: 30}}>
          <ul style={{ 
            margin: 0, 
            paddingLeft: 18, 
            color: '#0f172a', 
            fontSize: listaCidades.length > 20 ? 17 : 20, 
            fontWeight: 800, 
            lineHeight: listaCidades.length > 20 ? 1.36 : 1.46, 
            listStyleType: 'disc' 
          }}>
            {listaCidades.map((cidade, index) => {
              const formatada = (cidade || '').replace(/^autom[áa]tico\s+/i, '').trim();
              return (
                <li key={index} style={{ marginBottom: 1 }}>{formatada}</li>
              );
            })}
          </ul>
        </Col>
      </Row>
    </SlideContainer>
  );
};